import { TUseTermsAndConditions } from '@/shared/hooks/use-terms-and-conditions/use-terms-and-conditions.types';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useReadTermsAndConditionsAcceptanceQuery } from '@/shared/redux/api/ident/ident-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

export const useTermsAndConditions = (): TUseTermsAndConditions => {
  const user = useAppSelector(selectUser);
  const { data, isLoading } = useReadTermsAndConditionsAcceptanceQuery(
    undefined,
    { skip: !user?.userId },
  );

  const acceptance = data?.readTermsAndConditionsAcceptance;
  const isLatestAccepted = Boolean(
    acceptance?.latestTermsAndConditionsVersionAccepted,
  );
  // Previously accepted an earlier version, but a newer one now requires
  // re-acceptance.
  const isNewVersionAvailable = Boolean(
    acceptance?.accepted && !isLatestAccepted,
  );

  return {
    acceptance,
    isLatestAccepted,
    isNewVersionAvailable,
    isLoading,
  };
};
